import OverviewVM from './overview-vm';
import UserPreferencesVM from './user-preferences-vm';
import EmailPreferencesVM from './email-preferences-vm';
import SubscriptionVM from './subscription-vm.js';
import AccountVM from './account-vm.js';

export default {
  init() {
    const profileData = {
      ...JSON.parse(document.getElementById('user_settings_json').value),
      current_password: null,
      password: null,
      password_confirmation: null
    }

    const tzData = JSON.parse(document.getElementById('timezones_json').value)
    const langData = JSON.parse(document.getElementById('languages_json').value)
    const emailPrefsData = JSON.parse(document.getElementById('email_preferences_json').value)

    const overviewVM = new OverviewVM(profileData);

    ko.applyBindingsWithValidation(
      overviewVM,
      document.getElementById('user_edit'),
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    )

    ko.applyBindingsWithValidation(
      new UserPreferencesVM(profileData, tzData, langData),
      document.getElementById('userprefs'),
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    )

    ko.applyBindingsWithValidation(
      new EmailPreferencesVM(emailPrefsData),
      document.getElementById('emailprefs'),
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    )

    const el = document.getElementById('subscriptionstatus')

    if (el)
      ko.applyBindingsWithValidation(
        new SubscriptionVM(profileData),
        el,
        Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
      )

    ko.applyBindingsWithValidation(
      new AccountVM(profileData, overviewVM),
      document.getElementById('account'),
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    )
  }
};
